// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qB5l","comment":"styles_comment___59Gc"};